import {types} from "mobx-state-tree";

export const sDateType = types.custom({
    name: "sdate",
    fromSnapshot(value) {
        return value ? new Date(value) : null;
    },
    toSnapshot(value) {
        return value ? value.toString() : ""
    },
    isTargetType(value) {
        return 1;// new Date(value) || typeof value == 'string'
    },
    getValidationMessage(value) {
        return ""
        // if this.isTargetType(value) return "" // OK
        // return `'${value}' doesn't look like a valid decimal number`
    }
})